import { DispatchHistoryReport, Constants } from '../../../../../core';


export const dispatchHistoryReport = {
  searchText: '',
  sort: true,
  dialogHability: true,
  filter: false,
  alterColumns: true,
  paginator: true,
  checkbox: false,
  export: true,
  exportAllData: true,
  exportFile: 'reporte_movimientos.xlsx',
  expandable: false,
  disabled: false,
  partialField: '',
  columns: [
    {
      title: 'Evento',
      name: 'event',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.eventDescription
    },
    {
      title: 'Código de N/V',
      name: 'saleNoteId',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.saleNoteId
    },
    {
      title: 'Código de despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.dispatchId
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.skuCode
    },
    {
      title: 'Secuencial del item',
      name: 'skuPartialSequence',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.skuPartialSequence
    },
    {
      title: 'LPN',
      name: 'lpn',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.lpn
    },
    {
      title: 'Descripción',
      name: 'productDescription',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.description.replace('�', '')
    },
    {
      title: 'Estado del despacho',
      name: 'dispatchStatus',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.dispatchStatusDescription
    },
    {
      title: 'Entidad actual',
      name: 'currentEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.currentEntityName
    },
    {
      title: 'Entidad destino',
      name: 'nextEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.nextEntityName
    },
    {
      title: 'Cantidad procesada',
      name: 'units',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.units
    },
    {
      title: 'Origen de la transacción',
      name: 'origin',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.origin
    },
    {
      title: 'Fecha de venta',
      name: 'saleDate',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.saleDate
    },
    {
      title: 'Fecha de transacción',
      name: 'stateDate',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.stateDate
    },
    {
      title: 'Usuario',
      name: 'username',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.username
    },
    {
      title: 'Código del viaje',
      name: 'dispatchTripId',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.dispatchTripId
    },
    {
      title: 'Código de localización',
      name: 'locationCode',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.locationWithdrawal
    },
    {
      title: 'Motivo del rechazo',
      name: 'rejectName',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.rejectName
    },
    {
      title: 'Motivo de cancelación',
      name: 'reasonCancellation',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.reasonCancellation
    },
    {
      title: 'Agrupación de entidad',
      name: 'groupName',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center',
      value: (element: DispatchHistoryReport) => element.groupName
    },
    {      
      title: '',
      name: 'stateDispatch',
      type: 'editableColumns',
      visible: true,
      editable: true,
      checkAll: true,
      class: 'width-none',
      value: () => ''
    },
  ]
};
